import { BorderColor } from "@mui/icons-material";
import { darken } from "@mui/material";

const MuiTextField = {
  styleOverrides: {
    root: ({theme} : any) => ({
      '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':{
        borderColor:darken(theme.palette.background.default, 0.2)
      },
      '.MuiInputBase-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':{
        borderColor:darken(theme.palette.background.default,0.2)
      },
      'input::placeholder, textarea::placeholder': {
        fontStyle: 'italic',
        color: theme.palette.text.secondary,
      }
    }),
  },
};

export default MuiTextField;
